export const EXPO_CONFIG = {
    // nom de la taula de tesaurus i tld de la exposició a Dédalo
    table: 'ts_carmen_huder_carlosena',
    tld: 'navarra500',

    // section_id del terme arrel del tesaurus
    rootId: 1,

    // section_id del terme que te com a fills les pàgines de la exposició en ordre
    chaptersParentId: 2,

    // nivell de profunditat on estan les pàgines de la exposició
    chaptersLevelsDeep: 1,

    // section_id dels termes de les pàgines especials
    specialPages: {
        timeline: 12,
        learnMore: 13,
        credits: 15,
        report: 16,
    },
};
